document.addEventListener('DOMContentLoaded', function() {
    // Trouver tous les conteneurs de guide des tailles
    const containers = document.querySelectorAll('.size-guide-container');
    
    containers.forEach(container => {
      const htmlContainer = container;
      if (!(htmlContainer instanceof HTMLElement)) return;
      
      const productId = htmlContainer.dataset.productId;
      const trigger = htmlContainer.querySelector('.js-size-guide-trigger');
      const contentContainer = document.querySelector(`#size-guide-offcanvas-${productId} .js-size-guide-content`);
      let contentLoaded = false;
  
      if (trigger && contentContainer && trigger instanceof HTMLElement && contentContainer instanceof HTMLElement) {
        trigger.addEventListener('click', async function(e) {
          // Si le contenu est déjà chargé, ne rien faire
          if (contentLoaded) return;
  
          const url = this.dataset.sizeGuideUrl;
          
          if (!url) {
            console.error('URL du guide des tailles non trouvée');
            return;
          }
  
          try {
            const response = await fetch(url);
            
            if (!response.ok) {
              throw new Error('Erreur lors du chargement');
            }
  
            const html = await response.text();
            
            // Parser le HTML pour extraire le contenu de la page
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const pageContent = doc.querySelector('.page-content, .rte, main, .page__content');
            
            if (pageContent) {
              contentContainer.innerHTML = pageContent.innerHTML;
            } else {
              // Fallback : utiliser tout le body si pas de sélecteur trouvé
              contentContainer.innerHTML = doc.body.innerHTML;
            }
            
            contentLoaded = true;
            
          } catch (error) {
            console.error('Erreur:', error);
            contentContainer.innerHTML = '<p style="color: red; padding: 2rem; text-align: center;">Une erreur est survenue lors du chargement du guide des tailles.</p>';
          }
        });
      }
    });
  });